import { call, put, takeLatest } from 'redux-saga/effects';

import * as podcastActions from './podcastActions.js';
import { updatePodcastApiCall } from './podcastApi.js';

function* updatePodcastSaga({ payload }) {
  try {
    const { data } = yield call(updatePodcastApiCall, payload);
    yield put(podcastActions.podcastUpdateStore(data));
  } catch (error) {
    yield put(podcastActions.podcastUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* podcastWatcher() {
  yield takeLatest(podcastActions.podcastUpdateRequest.type, updatePodcastSaga);
}
